import { useEffect, useState } from 'react';
import { supabase } from '../supabase';
import './dashboard.css';

function formatDate(iso) {
  if (!iso) return '—';
  try {
    return new Date(iso).toLocaleString(undefined, {
      dateStyle: 'medium',
      timeStyle: 'short',
    });
  } catch {
    return String(iso);
  }
}

export default function Leads() {
  const [rows, setRows] = useState([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    async function load() {
      setError('');
      setLoading(true);
      try {
        const { data, error: qErr } = await supabase
          .from('leads')
          .select(
            'id, customer_name, customer_phone, what_they_need, urgency_level, best_callback_time, status, created_at'
          )
          .order('created_at', { ascending: false });

        if (qErr) throw qErr;
        if (!cancelled) setRows(data ?? []);
      } catch (e) {
        if (!cancelled) setError(e?.message ?? 'Failed to load leads.');
      } finally {
        if (!cancelled) setLoading(false);
      }
    }

    load();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="page">
      <h1 className="page-title">Leads</h1>
      {error ? <p className="page-error">{error}</p> : null}
      <div className="table-wrap">
        <table className="data-table">
          <thead>
            <tr>
              <th>Customer name</th>
              <th>Customer phone</th>
              <th>What they need</th>
              <th>Urgency</th>
              <th>Best callback time</th>
              <th>Status</th>
              <th>Created at</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={7} className="table-muted">
                  Loading…
                </td>
              </tr>
            ) : rows.length === 0 ? (
              <tr>
                <td colSpan={7} className="table-muted">
                  No leads found.
                </td>
              </tr>
            ) : (
              rows.map((row) => (
                <tr key={row.id}>
                  <td>{row.customer_name ?? '—'}</td>
                  <td>{row.customer_phone ?? '—'}</td>
                  <td>{row.what_they_need ?? '—'}</td>
                  <td>{row.urgency_level ?? '—'}</td>
                  <td>{row.best_callback_time ?? '—'}</td>
                  <td>{row.status ?? '—'}</td>
                  <td>{formatDate(row.created_at)}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
